import FixedAspectRatioImg from "parent/src/js/base/Controllers/FixedAspectRatioImg";

class BaseBlock {

	/**
	 * @type {FixedAspectRatioImg|null}
	 */
	fixedAspectRatioImg = null;
	maintainAspectRatio = false;

    /**
     *
     * @param {HTMLElement} element
	 * @param {number} index
     */
    constructor(element, index) {
		this.block = element;
		this.index = index;

		this.maintainAspectRatio = this.block.classList.contains("maintain-aspect-ratio");

		if (this.maintainAspectRatio) {
			this.fixedAspectRatioImg = new FixedAspectRatioImg(this.block.querySelector(".maintain-aspect-ratio img"));

			window.addEventListener("resize", this.onWindowResize.bind(this));
			this.updateSize();
		}
    }

    init() {
		throw new Error(this.block.dataset.block + " has not been initialized!");
    }

    /**
     * @return {string}
     */
    getBlockDataId() {
        return this.block.dataset.blockId;
    }

	/**
	 * @return {string}
	 */
	getBlockType() {
		return this.block.dataset.block;
	}

    getBlockSelector(subselect = "") {
        let selector = `section.acf-block[data-block-id="${this.getBlockDataId()}"]`;
        if (subselect !== "") {
            selector = selector.concat(` ${subselect}`);
        }
        return selector;
    }

	updateSize() {
		this.block.style.minHeight = this.fixedAspectRatioImg.getRealHeight().toString().concat("px");
	}

	onWindowResize() {
		this.updateSize();
	}
}

export default BaseBlock;
